/**
 * @generated SignedSource<<91c22bfef0147c1d94e611523ace0f19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow_fieldSets$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fieldSetId: string | null | undefined;
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly __id: string;
            readonly fieldId: string;
            readonly id: string;
            readonly type: string;
            readonly " $fragmentSpreads": FragmentRefs<"AffectedServicesCell" | "AtlasProjectCell" | "CascadingSelectCell" | "CheckboxSelectCell" | "CmdbObjectsCell" | "CommentSummaryCell" | "ComponentsCell_ComponentsInlineEditCell" | "ConfluencePagesCell" | "DateInlineEditCell" | "DateInlineEditCell_DateInlineEditCell" | "DateTimeCell" | "EpicLinkCell" | "FallbackCell" | "FlagCell" | "GoalsCell" | "IssueKeyCell" | "IssueLinksCell" | "IssueStatusCategoryCell" | "IssueStatusCell" | "IssueSummaryCell" | "IssueTypeCell" | "LabelsCell" | "LinkRelationshipTypeCell_fieldRef" | "MultiGroupPickerCell" | "MultiSelectCell" | "MultiUserPickerCell" | "MultiVersionPickerCell" | "NumberCell" | "OriginalEstimateCell" | "OriginalEstimateCell_OriginalEstimateCellNew" | "ParentCell" | "PlainTextCellOld" | "PriorityCell" | "ProjectCell" | "RadioSelectCell" | "RequestTypeCell" | "ResolutionCell" | "RichTextCell" | "SingleSelectCell" | "SprintCell" | "TeamCell" | "TimelineCellRenderer" | "UrlCell" | "UserCellInternal" | "WatchersCell">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting">;
  readonly " $fragmentType": "IssueRow_fieldSets";
};
export type IssueRow_fieldSets$key = {
  readonly " $data"?: IssueRow_fieldSets$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "type"
},
v1 = {
  "kind": "Variable",
  "name": "isInlineEditingEnabled",
  "variableName": "isInlineEditingEnabled"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "isEditableSyncLoaded",
    "variableName": "isEditableSyncLoaded"
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow_fieldSets",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormatting"
        }
      ]
    },
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            },
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "totalCount"
                },
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "id"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fieldId"
                        },
                        (v0/*: any*/),
                        {
                          "kind": "FragmentSpread",
                          "name": "AffectedServicesCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "CascadingSelectCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "CmdbObjectsCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "ComponentsCell_ComponentsInlineEditCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "DateInlineEditCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "DateInlineEditCell_DateInlineEditCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "DateTimeCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "EpicLinkCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "FallbackCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueKeyCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueStatusCategoryCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "IssueStatusCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "IssueSummaryCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "LabelsCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueTypeCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "ParentCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "PriorityCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "ProjectCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "ResolutionCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "SprintCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "UserCellInternal"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "PlainTextCellOld"
                        },
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isDensityFull",
                              "variableName": "isDensityFull"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "RichTextCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "RequestTypeCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueLinksCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "NumberCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "CommentSummaryCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "UrlCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "SingleSelectCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "MultiSelectCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "CheckboxSelectCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "MultiUserPickerCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "TeamCell"
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                          "kind": "Condition",
                          "passingValue": false,
                          "selections": [
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "OriginalEstimateCell"
                            }
                          ]
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "OriginalEstimateCell_OriginalEstimateCellNew"
                            }
                          ]
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "RadioSelectCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "MultiVersionPickerCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "GoalsCell"
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "AtlasProjectCell"
                            }
                          ]
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "ConfluencePagesCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "MultiGroupPickerCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "FlagCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "WatchersCell"
                        },
                        {
                          "condition": "isLinkRelationshipFieldEnabled",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "args": (v3/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "LinkRelationshipTypeCell_fieldRef"
                            }
                          ]
                        },
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isTimelineEnabled",
                              "variableName": "isTimelineEnabled"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "TimelineCellRenderer"
                        },
                        {
                          "kind": "ClientExtension",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "__id"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "1a723aacdbbf7f366e4e0e6d9464bb44";

export default node;
